export enum ClinicalParameters {
  QT_PA_SISTOLICA__ATENDIMENTO_SINAL_VITAL,
  QT_PA_DIASTOLICA__ATENDIMENTO_SINAL_VITAL,
  QT_FREQ_RESP__ATENDIMENTO_SINAL_VITAL,
  QT_TEMP__ATENDIMENTO_SINAL_VITAL,
  QT_SATURACAO_O2__ATENDIMENTO_SINAL_VITAL,
  QT_PAM__ATENDIMENTO_SINAL_VITAL,
  QT_FREQ_CARDIACA__ATENDIMENTO_SINAL_VITAL,
  QT_ESCALA_DOR__ATENDIMENTO_SINAL_VITAL,
  QT_BCF__ATENDIMENTO_SINAL_VITAL,
  QT_PESO__ATENDIMENTO_SINAL_VITAL,
  QT_ALTURA_CM__ATENDIMENTO_SINAL_VITAL,
  QT_ALTURA_M__ATENDIMENTO_SINAL_VITAL,
  QT_SUPERF_CORPORIA__ATENDIMENTO_SINAL_VITAL,
  QT_PVC__ATENDIMENTO_SINAL_VITAL,
  QT_PRESSAO_INTRA_CRANIO__ATENDIMENTO_SINAL_VITAL,
  QT_PRESSAO_INTRA_ABD__ATENDIMENTO_SINAL_VITAL,
  QT_TEMP_INCUBADORA__ATENDIMENTO_SINAL_VITAL,
  QT_BCF_2__ATENDIMENTO_SINAL_VITAL,
  QT_BCF_3__ATENDIMENTO_SINAL_VITAL,
  QT_PERIODO__ATENDIMENTO_SINAL_VITAL,
  QT_O2_SUPLEMENTAR__ATENDIMENTO_SINAL_VITAL,
  QT_SPO2R__ATENDIMENTO_SINAL_VITAL,
  QT_PPA__ATENDIMENTO_SINAL_VITAL,
  QT_PIC_TEMP__ATENDIMENTO_SINAL_VITAL,
  QT_PPC__ATENDIMENTO_SINAL_VITAL,
  QT_MAEC__ATENDIMENTO_SINAL_VITAL,
  QT_PESO_ATUAL__ATENDIMENTO_SINAL_VITAL,
  QT_UMID_INCUBADORA__ATENDIMENTO_SINAL_VITAL,
  QT_TEMP_BERCO__ATENDIMENTO_SINAL_VITAL,
  QT_BILIRRUBINA_TRONCO__ATENDIMENTO_SINAL_VITAL,
  QT_BILIRRUBINA_FRONTE__ATENDIMENTO_SINAL_VITAL,
  QT_IRRADIANCIA__ATENDIMENTO_SINAL_VITAL,
}